
import React, { Component, Suspense, lazy } from "react";

import "./App.css?ver=1";
import './components/Header/Header.css';
import './components/Main/Main.css';
import './components/FitAgGrid/FitAgGridContainer.css';

import { Route, Switch, Redirect } from "react-router-dom";


import AuthContainer from "./components/LoginSignup/AuthContainer";
import Login from "./components/LoginSignup/Login";
import SellIPOShares from "./components/LoginSignup/SellIPOShares";

// import Signup from "./components/LoginSignup/Signup";
import ForgetPassword from "./components/LoginSignup/ForgetPassword";
import ForgotUsername from "./components/LoginSignup/ForgotUsername";
import OTP from "./components/LoginSignup/OTP";
import MobileVerification from "./components/LoginSignup/MobileVerification";

import ChangePassword from "./components/LoginSignup/ChangePassword";

import { isLoggedIn } from './global/Helpers';

import * as AppUrls from './constants/AppUrls';
import * as Helpers from './global/Helpers';
import * as Licences from './global/Licences';
import * as Constants from './constants/Constants';

import { withTranslation } from 'react-i18next';

import SplashScreenImage from "./assets/images/splash_icons/Shuaa_splach_center.png?ver=1"
// import SplashScreenImage from "./assets/images/splash_icons/IS_logo_icon_white.png"
import { confirmAlert } from "react-confirm-alert";
import { LicenseManager } from "ag-grid-enterprise";


import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import firebase from '././global/firebase';
// import ReactGA from 'react-ga'; //Google Analytics:

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';

import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import SpinnersLoadingSIP from './components/SpinnersLoadingSIP/SpinnersLoadingSIP';
import OnboardingLogin from './components/OnboardingSystem/OnboardingLogin/OnboardingLogin';
import OnboardingOTP from './components/OnboardingSystem/OnboardingOTP/OnboardingOTP';
import OnboardingCustomerInformation from './components/OnboardingSystem/OnboardingCustomerInformation/OnboardingCustomerInformation';
import ConfirmPassportDetails from './components/OnboardingSystem/ConfirmPassportDetails/ConfirmPassportDetails';
import OnboardingHome from './components/OnboardingSystem/OnboardingHome/OnboardingHome';
import UploadTradeLicense from "./components/OnboardingSystem/UploadTradeLicense/UploadTradeLicense ";
import MainOuterOnboarding from "./components/OnboardingSystem/MainOuterOnboarding/MainOuterOnboarding";
import OnboardingMinor from "./components/OnboardingSystem/OnboardingMinor/OnboardingMinor";
import MinorEIDInfo from "./components/OnboardingSystem/OnboardingMinor/MinorEIDInfo";
import MinorPassport from "./components/OnboardingSystem/OnboardingMinor/MinorPassport";
import ConfirmPassportMinor from "./components/OnboardingSystem/OnboardingMinor/ConfirmPassportMinor";

// import MobileDetect from 'mobile-detect';
// import $ from "jquery";
 
toast.configure();

const Container = React.lazy(() => import('./components/Main/Container'));

class App extends Component {
  abortController = new window.AbortController();
  constructor(props) {
    super(props);
    this.state = {
      value: "en",
      isPopulated: false,
      redirect: null,
      isMobile: false,
      isLoaderVisible: false
    }

    this.getConfig();
    window.appComponent = this;
    // if (window.orientation == 0) {
    //   document.getElementById('portrait').style.display = '';
    //   document.getElementById('landscape').style.display = 'none';
    // }
    // else if (window.orientation == 90) {
    //   document.getElementById('portrait').style.display = 'none';
    //   document.getElementById('landscape').style.display = '';
    // }
    //const [isMobile, setIsMobile] = useState(true);
    // var md = new MobileDetect(window.navigator.userAgent);
    // //var x = md.is('iPhone');
    // if (md.os()) {
    //   if (md.os().toUpperCase() == 'IOS') {
    //     this.setState({ isMobile: true });
    //   }
    //   else if (md.os().toUpperCase() == 'ANDROIDOS') {
    //     this.setState({ isMobile: true });
    //   }
    //   else {
    //     this.getConfig();
    //     window.appComponent = this;
    //   }
    // } else {
    //   this.getConfig();
    //   window.appComponent = this;
    // }
  }

  getConfig = () => {

    LicenseManager.setLicenseKey(Licences.RelatedLicences.LicencesAgGrid);

    fetch(process.env.PUBLIC_URL + '/config.json?var=' + Math.random(), {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((r) => r.json())
      .then((config) => {

        //console.log("config response: ", data);
        var data = config.relatedConfig[config.company_name];
        document.title = data.website_name;
        //  $("#fav").attr("href",)
        //1. remove old values

        Helpers.removeExistingItem(Constants.localStorageConstants.app_path);
        Helpers.removeExistingItem(Constants.localStorageConstants.company_name);
        Helpers.removeExistingItem(Constants.localStorageConstants.Region);
        Helpers.removeExistingItem(Constants.localStorageConstants.server_url);
        Helpers.removeExistingItem(Constants.localStorageConstants.chart_iq_url);
        Helpers.removeExistingItem(Constants.localStorageConstants.chart_trading_url);
        Helpers.removeExistingItem(Constants.localStorageConstants.signalr_url);
        Helpers.removeExistingItem(Constants.localStorageConstants.signalr_hub);
        Helpers.removeExistingItem(Constants.localStorageConstants.last_Work_day);
        Helpers.removeExistingItem(Constants.localStorageConstants.Foreign_Market);
        Helpers.removeExistingItem(Constants.localStorageConstants.PortfolioProvider);
        Helpers.removeExistingItem(Constants.localStorageConstants.EnableTags);
        Helpers.removeExistingItem(Constants.localStorageConstants.EnableIPOQuickSell);
        Helpers.removeExistingItem(Constants.localStorageConstants.EnableSymbolFullName);
        Helpers.removeExistingItem(Constants.localStorageConstants.EnableMarketWatchCache);
        Helpers.removeExistingItem(Constants.localStorageConstants.RegulaUrl);
        Helpers.removeExistingItem(Constants.localStorageConstants.FullTradeLimit);
        Helpers.removeExistingItem(Constants.localStorageConstants.RealTimePortfolioUpdate);
        Helpers.removeExistingItem(Constants.localStorageConstants.PortfoliRefreshDelay);


        //2. set new values
        localStorage.setItem(Constants.localStorageConstants.app_path, data.app_path);
        localStorage.setItem(Constants.localStorageConstants.company_name, data.company_name);
        localStorage.setItem(Constants.localStorageConstants.Region, data.Region);
        localStorage.setItem(Constants.localStorageConstants.server_url, data.server_url);
        localStorage.setItem(Constants.localStorageConstants.chart_iq_url, data.chart_iq_url);
        localStorage.setItem(Constants.localStorageConstants.chart_trading_url, data.chart_trading_url);
        localStorage.setItem(Constants.localStorageConstants.signalr_url, data.signalr_url);
        localStorage.setItem(Constants.localStorageConstants.signalr_hub, data.signalr_hub);
        localStorage.setItem(Constants.localStorageConstants.last_Work_day, data.last_Work_day);
        localStorage.setItem(Constants.localStorageConstants.Foreign_Market, data.Foreign_Market);
        localStorage.setItem(Constants.localStorageConstants.PortfolioProvider, data.PortfolioProvider);
        localStorage.setItem(Constants.localStorageConstants.EnableTags, data.EnableTags);
        localStorage.setItem(Constants.localStorageConstants.EnableIPOQuickSell, data.EnableIPOQuickSell);
        localStorage.setItem(Constants.localStorageConstants.EnableSymbolFullName, data.EnableSymbolFullName);
        localStorage.setItem(Constants.localStorageConstants.EnableMarketWatchCache, data.EnableMarketWatchCache);
        localStorage.setItem(Constants.localStorageConstants.RegulaUrl, data.RegulaUrl);
        localStorage.setItem(Constants.localStorageConstants.FullTradeLimit, data.FullTradeLimit);
        localStorage.setItem(Constants.localStorageConstants.RealTimePortfolioUpdate, data.RealTimePortfolioUpdate);
        localStorage.setItem(Constants.localStorageConstants.PortfoliRefreshDelay, data.PortfoliRefreshDelay);


        //3. update urls
        Constants.updateUrls(data.server_url, data.signalr_url, data.signalr_hub);
        AppUrls.updateAppUrls(data.app_path);

        //4. set isPopulated to finish splash screen
        this.setState({ isPopulated: true });

      })
  }

  componentDidMount() {
    // var messaging = firebase.messaging();
    if (this.props.i18n.language === "ar" && localStorage.getItem("language") !== null && localStorage.getItem("language") === "ar") {
      this.props.i18n.changeLanguage("ar");
      this.setState({ value: "ar" });
    }
    // Google Analytics
    // ReactGA.initialize('UA-150693920-1');
    // ReactGA.pageview(window.location.pathname + window.location.search);

    // // GetToken for client (firebase notification):
    // messaging.getToken({ vapidKey: 'BH_g7O3bUxHx9JUpBAi0Ko673EL3I2eqzGSK-QTz59Hz1dbe-ngF40Kyh1Qn1hQhS2Tg2Fi5PvmjZLeVg_fIuYg' }).then((currentToken) => {
    //   if (currentToken) {
    //     console.log('current token for client: ', currentToken);
    //   } else {

    //     console.log('No registration token available. Request permission to generate one.');

    //   }
    // }).catch((err) => {
    //   console.log('An error occurred while retrieving token. ', err);

    // });

  }

  changeLanguageNew = () => {

    var newlang = "";
    if (this.state.value === "en") {
      newlang = "ar";
    } else {
      newlang = "en";
    }
    localStorage.setItem("language", newlang);
    localStorage.setItem("LanguageSelectedFromLogin", newlang);
    localStorage.setItem("isLanguageSelectedFromLogin", true);
    this.setState({ value: newlang });
    this.props.i18n.changeLanguage(newlang);




  };

  errorHandling = () => {

    confirmAlert({
      // title: 'Confirm to submit',
      message: this.props.i18n.t("sessionclientexpired"),
      buttons: [
        {
          label: 'Ok',
          onClick: () => {
            let UserName = localStorage.getItem("username");
            let RememberMe = localStorage.getItem("isRememberMe");
            let language = localStorage.getItem("language");
            localStorage.clear();
            if (RememberMe !== undefined || RememberMe !== null) {
              localStorage.setItem("isRememberMe", RememberMe);
            }
            if (RememberMe === "true") {
              if (UserName !== undefined || UserName !== null) {
                localStorage.setItem("username", UserName);
              }
            }
            if (language !== undefined || language !== null) {
              localStorage.setItem("language", language === "null" ? "en" : language);
            }
            // localStorage.removeItem("user");
            Helpers.emptyCache();
          }
        }
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    })

    setTimeout(() => {
      let UserName = localStorage.getItem("username");
      let RememberMe = localStorage.getItem("isRememberMe");
      let language = localStorage.getItem("language");
      localStorage.clear();
      if (RememberMe !== undefined || RememberMe !== null) {
        localStorage.setItem("isRememberMe", RememberMe);
      }
      if (RememberMe === "true") {
        if (UserName !== undefined || UserName !== null) {
          localStorage.setItem("username", UserName);
        }
      }
      if (language !== undefined || language !== null) {
        localStorage.setItem("language", language === "null" ? "en" : language);
      }
      // localStorage.removeItem("user");
      Helpers.emptyCache();
    }, 10000);
  };

  errorNotify = (message) => {
    toast.error(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      hideProgressBar: true,
      autoClose: Constants.errorNotifyDuration
    });
  };

  setIsLoaderVisible = (isLoaderVisible) => {
    if (this.state.isLoaderVisible !== isLoaderVisible)
      this.setState({ isLoaderVisible: isLoaderVisible });
  }

  getLoader = (isLoaderVisible) => {
    return (
      isLoaderVisible
        ? <div className="container-loader">
          <div style={localStorage.getItem(Constants.localStorageConstants.company_name) === "SIFS" ? { height: "100%" } : { display: "inline-block", top: "40%", position: "absolute" }}>
            {localStorage.getItem(Constants.localStorageConstants.company_name) === "SIFS" ? <SpinnersLoadingSIP /> :
              <Loader
                type="Bars"
                color="#00BFFF"
                height={100}
                width={100}
                visible={true}
              />}
          </div>
        </div>
        : null
    )
  }

  render() {
    // 
    let mobileView = Helpers.getIsIPad() ? "mobile-view" : "web-view"
    let companyName = localStorage.getItem(Constants.localStorageConstants.company_name) + "-CSS"
    let appClassLanguage = "app-en " + mobileView;
    if (this.props.i18n.language === "ar") {
      appClassLanguage = "app-ar " + mobileView;
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }
    // var isMobile = false
    // var md = new MobileDetect(window.navigator.userAgent);
    // //var x = md.is('iPhone');
    // if (md.os()) {
    //   if (md.os().toUpperCase() == 'IOS') {
    //     isMobile = true;
    //     window.location = Constants.redirectMobileURLS.IOS;
    //   }
    //   else if (md.os().toUpperCase() == 'ANDROIDOS') {
    //     isMobile = true;
    //     window.location = Constants.redirectMobileURLS.Android;
    //   }
    //   else {
    //     isMobile = false;
    //   }
    // } else {
    //   isMobile = false;
    // }

    return (
      <div className={companyName} style={{ height: "100%" }}>
        <div className={"App " + appClassLanguage} style={{ height: "100%" }}>
          {
            !this.state.isPopulated
              ? <div
                className="splash-screen">
                {localStorage.getItem(Constants.localStorageConstants.company_name) === "IFS" ?
                  <img
                    className="splash-image"
                    src={SplashScreenImage}
                    style={{
                      backgroundColor: "transparent",
                      height: "100%",
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block",

                    }}
                    alt=""
                  />
                  : this.getLoader(true)
                }

              </div>
              : <Switch>

                <Route
                  exact={true}
                  path={AppUrls.login}
                  render={(props) =>
                    isLoggedIn(this.abortController)
                      ? (
                        <Redirect to={AppUrls.trading} />
                      ) : (
                        <AuthContainer
                          {...props}
                          title={this.props.t("Login")}
                          subTitle={this.props.t("WelcomeMessage")}

                          form={<Login changeLanguageNew={this.changeLanguageNew} />}
                        />
                      )
                  }
                />
                <Route
                  path={AppUrls.trading}
                  render={() =>
                    isLoggedIn(this.abortController)
                      ? <Suspense
                        fallback={
                          <div
                            className="splash-screen">
                            {localStorage.getItem(Constants.localStorageConstants.company_name) === "IFS" ?
                              <img
                                className="splash-image"
                                src={SplashScreenImage}
                                style={{ backgroundColor: "transparent", height: "100%", marginLeft: "auto", marginRight: "auto", display: "block" }}
                                alt=""
                              />
                              : this.getLoader(true)


                            }


                          </div>
                        }>
                        <Container
                          changeLanguageNew={this.changeLanguageNew}
                          langValue={this.state.value}
                        />
                      </Suspense>
                      : <Redirect to={AppUrls.login} />


                  }
                />

                <Route
                  path={AppUrls.fitGrid}
                  render={() =>
                    isLoggedIn(this.abortController)
                      ? <Suspense fallback={
                        <div
                          className="splash-screen">

                          {localStorage.getItem(Constants.localStorageConstants.company_name) === "IFS" ?
                            <img
                              className="splash-image"
                              src={SplashScreenImage}
                              style={{ backgroundColor: "transparent", height: "100%", marginLeft: "auto", marginRight: "auto", display: "block" }}
                              alt=""
                            />
                            : this.getLoader(true)

                          }
                        </div>
                      }>
                        <Container
                          changeLanguageNew={this.changeLanguageNew}
                          layout={Constants.Layouts.fit_ag_grid}
                          langValue={this.state.value}
                        />
                      </Suspense>
                      : <Redirect to={AppUrls.login} />


                  }
                />

                {/* <Route
                path={AppUrls.signUp}
                render={(props) => (
                  <AuthContainer
                    {...props}
                    title={this.props.t("Signup")}
                    subTitle={this.props.t("SignupDesc")}
                    form={<Signup />}
                    i18n={this.props.i18n}
                  />
                )}
              /> */}

                <Route
                  path={AppUrls.forgetPassword}
                  render={(props) => (
                    <AuthContainer
                      {...props}
                      title={this.props.t("resetPassword")}
                      subTitle={this.props.t("resetPassword")}
                      form={<ForgetPassword />}
                      i18n={this.props.i18n}
                    />
                  )}
                />
                <Route
                  path={AppUrls.ForgotUsername}
                  render={(props) => (
                    <AuthContainer
                      {...props}
                      title={this.props.t("ForgotUsername")}
                      subTitle={this.props.t("ForgotUsername")}
                      form={<ForgotUsername />}
                      i18n={this.props.i18n}
                    />
                  )}
                />
                <Route
                  path={AppUrls.SellIPOShares}
                  render={(props) => (
                    <AuthContainer
                      {...props}
                      title={this.props.t("IPO_Authintication")}
                      subTitle={this.props.t("IPO_Authintication")}
                      form={<SellIPOShares />}
                      i18n={this.props.i18n}
                    />
                  )}
                />

                <Route
                  path={AppUrls.otp}
                  render={(props) => (
                    <AuthContainer
                      {...props}
                      title={this.props.t("otpTitle")}
                      subTitle={this.props.t("otp")}
                      form={<OTP changeLanguageNew={this.changeLanguageNew} />}
                      i18n={this.props.i18n}
                    />
                  )}
                />
                <Route
                  path={AppUrls.Verification}
                  render={(props) => (
                    <AuthContainer
                      {...props}
                      title={""}
                      subTitle={""}
                      form={<MobileVerification  changeLanguageNew={this.changeLanguageNew} />}
                      i18n={this.props.i18n}
                    />
                  )}
                />
                <Route
                  path={AppUrls.changePassword}
                  render={(props) => (
                    <AuthContainer
                      {...props}
                      title={this.props.t("ChangePasswordTitle")}
                      subTitle={this.props.t("ChangePasswordDesc")}
                      form={<ChangePassword />}
                      i18n={this.props.i18n}
                    />
                  )}
                />
                <Route
                  path={AppUrls.TermsAndConditions}
                  render={(props) => (
                    <AuthContainer
                      {...props}
                      title={this.props.t("")}
                      subTitle={this.props.t("")}
                      form={<TermsAndConditions />}
                      i18n={this.props.i18n}
                    />
                  )}
                />
                <Route
                  path={AppUrls.onboarding}
                  render={(props) => (
                    <OnboardingHome />
                  )}
                />
                <Route
                  path={AppUrls.onboardingOTP}
                  render={(props) => (
                    <OnboardingOTP />
                  )}
                />
                <Route
                  path={AppUrls.CustomerInfo}
                  render={(props) => (
                    <OnboardingCustomerInformation />
                  )}
                />
                <Route
                  path={AppUrls.ConfirmPassportDetails}
                  render={(props) => (
                    <ConfirmPassportDetails />
                  )}
                />
                <Route
                  path={AppUrls.ConfirmPassportMinor}
                  render={(props) => (
                    <ConfirmPassportMinor />
                  )}
                />
                <Route
                  path={AppUrls.onboardingLogin}
                  render={(props) => (
                    <OnboardingLogin />
                  
                  )}
                />
                <Route
                  path={AppUrls.onboardingCorporate}
                  render={(props) => (
                    <UploadTradeLicense />
                  )}
                />
                <Route
                  path={AppUrls.onboardingMinor}
                  render={(props) => (
                    <OnboardingMinor /> 
                  )}
                />
                      <Route
                  path={AppUrls.MinorEIDInfo}
                  render={(props) => (
                    <MinorEIDInfo />
                  )}
                />
                      <Route
                  path={AppUrls.MinorPassportScan}
                  render={(props) => (
                    <MinorPassport />
                  )}
                />

                <Route
                  path={AppUrls.onboardingPersonal}
                  render={() =>
                    <Suspense
                      fallback={
                        <div
                          className="splash-screen">
                          {localStorage.getItem(Constants.localStorageConstants.company_name) === "IFS" ?
                            <img
                              className="splash-image"
                              src={SplashScreenImage}
                              style={{ backgroundColor: "transparent", height: "100%", marginLeft: "auto", marginRight: "auto", display: "block" }}
                              alt=""
                            />
                            : this.getLoader(true)
                          }
                        </div>
                      }>
                      <MainOuterOnboarding />
                    </Suspense>



                  }
                />

                <Route
                  path={AppUrls.any}
                  render={() =>
                    isLoggedIn(this.abortController)
                      ? <Redirect to={AppUrls.trading} />
                      : <Redirect to={AppUrls.login} />


                  }
                />



              </Switch>
          }
        </div>

      </div>

    );
  }
  componentWillUnmount() {
    //if (this.gridApi) this.gridApi.destroy();
    //if (this.channel) this.channel.close();
    if (this.abortController) this.abortController.abort();
  }
}

export default withTranslation()(App);
